import React from 'react';
interface BillRemarksProps {
  remarks?: string;
}
export function BillRemarks({
  remarks
}: BillRemarksProps) {
  return <div className="mb-6" data-id="element-130">
      <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-131">
        Remarks
      </h3>
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 min-h-[100px]" data-id="element-132">
        {remarks ? <p className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-133">
            {remarks}
          </p> : <p className="text-xs text-neutral-400 italic" data-id="element-134">
            No remarks provided.
          </p>}
      </div>
    </div>;
}